<template>
  <v-layout align-center align-baseline justify-center>
    <v-flex>
      <v-data-table
        :headers="headers"
        :items="facturas"
        :search="search"
        class="elevation-1"
        v-if="verNuevo == 0"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Sujeto Excluido</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="listar()"
                  ><v-icon class="fa fa-sync-alt"></v-icon
                ></v-btn>
              </template>
              <span>Actualizar</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Busqueda"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-menu
              v-if="verNuevo == 0"
              v-model="menuFechas"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
              transition="scale-transition"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mr-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  Opciones</v-btn
                >
              </template>
              <v-card>
                <v-list>
                  <v-list-item>
                    <v-text-field
                      v-model="fechaInicio"
                      hide-details
                      type="date"
                      label="Desde"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>

                  <v-list-item>
                    <v-text-field
                      v-model="fechaFin"
                      hide-details
                      type="date"
                      label="Hasta"
                      :max="new Date().toISOString().substr(0, 10)"
                      clearable
                    ></v-text-field>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" dark @click="filtrarFacturas()"
                      >Filtrar</v-btn
                    >
                    <v-btn
                      color="green"
                      dark
                      class="mx-2"
                      @click="generarObjetoExcel()"
                      >Descargar</v-btn
                    >
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
            <v-btn v-if="verNuevo == 0" color="primary" @click="abrirNuevo()"
              >Nuevo</v-btn
            >
          </v-toolbar>
        </template>
        <template v-slot:[`item.fechaCreacion`]="{ item }">
          {{formatoFecha(item.fechaCreacion)}}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small class="mr-2" @click="verDetalles(item)"> tab </v-icon>
        </template>
      </v-data-table>

      <v-overlay v-model="overlay" z-index="1">
        <lottie-player
          autoplay
          loop
          mode="normal"
          src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
          style="width: 320px"
        >
        </lottie-player>
      </v-overlay>

      <v-snackbar v-model="snackError" color="cyan darken-2" top
        >SUCEDIO ALGUN ERROR, VERIFICAR ESTADO DE CONEXIÓN, Y VUELVA A
        INTENTAR.</v-snackbar
      >

      <v-row v-if="verNuevo == 1">
        <v-col cols="12" class="pa-0">
          <v-toolbar>
            <v-checkbox
              v-model="banderaCuadricula"
              @change="habilitarCuadricula()"
              label="Habilitar cuadricula"
              hint="Al imprimir deshabilitar la cuadricula"
              persistent-hint
              class="ml-5"
            ></v-checkbox>
            <v-checkbox
              v-model="banderaTitulos"
              @change="habilitarTitulos()"
              label="Habilitar títulos"
              hint="Al imprimir deshabilitar los titulos"
              persistent-hint
              class="ml-5"
            ></v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              rounded
              color="grey"
              @click="cerrarNuevo()"
              class="ml-5"
              >Cancelar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="guardar()"
              v-if="verDet == 0"
              class="ml-5"
              >Guardar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="actualizar()"
              v-if="verDet == 1"
              class="ml-5"
              >Actualizar</v-btn
            >
            <v-btn
              outlined
              rounded
              color="blue"
              @click="imprimir()"
              class="ml-5"
              >Imprimir</v-btn
            >
          </v-toolbar>
        </v-col>
        <vue-html2pdf
          :show-layout="true"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="F1"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="792px"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
          class="mx-auto"
        >
          <section slot="pdf-content">
            <v-col cols="12">
              <!-- CAMPO VACIO -->
              <v-card
                max-width="800"
                height="130"
                elevation="0"
                style="margin-left: 25px; margin-right: 25px; margin-top: 25px"
              >
                <v-row no-gutters justify="end">
                  <v-col cols="auto" class="textStyle mt-12">
                    <div class="mt-2">No</div>
                  </v-col>
                  <v-col cols="1" class="mt-12">
                    <v-text-field
                      hide-details
                      class="some-style styleText"
                      dense
                      v-model="numFactura"
                      v-if="correlativo"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- DATOS PRINCIPALES -->
              <v-card max-width="792" height="auto" elevation="0">
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Fecha</div>
                  </v-col>
                  <v-col
                    cols="10"
                    style="
                      padding-left: 30px;
                      padding-top: 0px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="fecha"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Nombre de sujeto excluido</div>
                  </v-col>
                  <v-col
                    cols="7"
                    style="
                      padding-left: 30px;
                      padding-top: 0px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="nombre"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>Dirección</div>
                  </v-col>
                  <v-col
                    cols="6"
                    style="
                      padding-left: 30px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="direccion"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="auto" class="textStyle">
                    <div>Tel</div>
                  </v-col>
                  <v-col
                    cols="2"
                    style="
                      padding-left: 85px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="tel"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row style="margin: 0px" no-gutters>
                  <v-col cols="auto" class="textStyle">
                    <div>nitDui</div>
                  </v-col>
                  <v-col
                    cols="6"
                    style="
                      padding-left: 160px;
                      padding-top: 5px;
                      padding-bottom: 0px;
                      margin-top: 0px;
                    "
                  >
                    <v-text-field
                      hide-details
                      dense
                      height="15"
                      v-model="nitDui"
                      class="some-style styleText"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>

              <!-- DATOS DE TABLA -->
              <v-card
                max-width="792"
                height="115"
                elevation="0"
                style="
                  padding-left: 0px;
                  padding-top: 0px;
                  padding-bottom: 0px;
                  margin-top: 25px;
                  margin-left: 35px;
                  margin-right: 40px;
                "
              >
                <table style="border-collapse: collapse">
                  <tr style="height: 20px;">
                    <th style="width: 5%" class="textStyleTabla1">cant.</th>
                    <th
                      style="width: 45%; padding-right: 0px"
                      class="textStyleTabla1"
                    >
                      descripcion
                    </th>
                    <th
                      style="width: 8%; padding-right: 0px"
                      class="textStyleTabla1"
                    >
                      precio unitario
                    </th>
                    <th style="width: 8%; padding-right: 0px" class="textStyleTabla1">Total compras</th>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant1"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText"
                      >
                        {{ cant_1 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc1"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        class="styleText"
                      >
                        {{ descripcion_1 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="pu1"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText"
                      >
                        {{ precioUnitario_1 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va1"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ totalCompras_1 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant2"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText"
                        style=""
                      >
                        {{ cant_2 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc2"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        class="styleText"
                      >
                        {{ descripcion_2 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="pu2"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText"
                      >
                        {{ precioUnitario_2 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va2"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ totalCompras_2 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant3"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText"
                      >
                        {{ cant_3 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc3"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        class="styleText"
                      >
                        {{ descripcion_3 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="pu3"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText"
                      >
                        {{ precioUnitario_3 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va3"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ totalCompras_3 }}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div
                        id="cant4"
                        contenteditable="true"
                        @blur="cadenaCant()"
                        class="styleText"
                        style="margin-top: 3px"
                      >
                        {{ cant_4 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="desc4"
                        contenteditable="true"
                        @blur="cadenaDesc()"
                        class="styleText"
                      >
                        {{ descripcion_4 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="pu4"
                        contenteditable="true"
                        @blur="cadenaPU()"
                        class="styleText"
                      >
                        {{ precioUnitario_4 }}
                      </div>
                    </td>
                    <td>
                      <div
                        id="va4"
                        contenteditable="true"
                        @blur="sumasTabla()"
                        class="styleText"
                      >
                        {{ totalCompras_4 }}
                      </div>
                    </td>
                  </tr>
                </table>
              </v-card>

              <!-- DATOS FOOTER -->
              <v-card
                max-width="792"
                height="177"
                elevation="0"
                color="transparent"
                style="
                  padding-left: 0px;
                  padding-bottom: 0px;
                  margin-top: 0px;
                  margin-left: 40px;
                  margin-right: 42px;
                "
              >
                <v-row no-gutters>
                  <v-col cols="7">
                    <v-row no-gutters>
                      <v-col cols="12">
                        <div
                          style="
                            height: 73px;
                            padding-top: 0px;
                            padding-left: 25px;
                            padding-right: 0px;
                            margin-top: 15px
                          "
                          contenteditable="true"
                          class="styleText"
                        >
                          {{ cantidadLetras }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="5" style="background-color: white">
                    <table style="border-collapse: collapse">
                      <tr style="height: 25px">
                        <th style="width: 150%" class="textStyleTabla1">
                          sumas
                        </th>
                        <th style="width: 50%">
                          <div
                            id="sumas"
                            contenteditable="true"
                            class="styleText"
                          >
                            {{ sumas }}
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td style="height: 25px;">
                          <div contenteditable="true" class="textStyleTabla1">
                            Imp sobre la renta
                          </div>
                        </td>
                        <td>
                          <div
                            id="impRenta"
                            contenteditable="true"
                            class="styleText"
                          >
                            {{ impRenta }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Sub-Total
                          </div>
                        </td>
                        <td>
                          <div
                            id="subTotal"
                            contenteditable="true"
                            class="styleText"
                          >
                            {{ subTotal }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px">
                          <div contenteditable="true" class="textStyleTabla1">
                            Total
                          </div>
                        </td>
                        <td>
                          <div
                            id="total"
                            contenteditable="true"
                            @blur="conversionNumero()"
                            class="styleText"
                          >
                            {{ montoDolares }}
                          </div>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </section>
        </vue-html2pdf>
      </v-row>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import XLSX from "xlsx";
import moment from 'moment';
export default {
  data() {
    return {
      facturas: [],
      items: [],
      headers: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Fecha creación",
          value: "fechaCreacion",
          align: "left",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "left",
        },
        {
          text: "Nombre",
          value: "nombre",
          align: "left",
        },
        {
          text: "Dirección",
          value: "direccion",
          align: "left",
        },
        {
          text: "Nit o Dui",
          value: "nitDui",
          align: "left",
        },
        {
          text: "Teléfono",
          value: "tel",
          align: "left",
        },
        {
          text: "Sumas",
          value: "sumas",
          align: "left",
        },
      ],
      search: "",
      verNuevo: 0,
      verDet: 0,
      nombreClienteItem: "",
      correlativo: true,
      numFactura: "***",
      menuFechas: false,
      fechaInicio: "",
      fechaFin: "",
      overlay: false,
      snackError: false,
      idFactura: 0,
      idUsuario: 0,
      idBaseClienteFactura: 0,
      fechaCreacion: "",
      fecha: "Fecha",
      nombre: "***",
      nitDui: "***",
      direccion: "***",
      tel: "***",
      banderaCuadricula: true,
      banderaTitulos: true,
      cadenaCantidad: "",
      cant_1: "",
      cant_2: "",
      cant_3: "",
      cant_4: "",
      cadenaDescripcion: "",
      descripcion_1: "",
      descripcion_2: "",
      descripcion_3: "",
      descripcion_4: "",
      cadenaPrecioUnitario: "",
      precioUnitario_1: "",
      precioUnitario_2: "",
      precioUnitario_3: "",
      precioUnitario_4: "",
      cadenaTotalCompras: "",
      totalCompras_1: "",
      totalCompras_2: "",
      totalCompras_3: "",
      totalCompras_4: "",
      sumas: 0,
      impRenta: 0,
      subTotal: 0,
      montoDolares: 0,
      cantidadLetras: "",
      exportData: [],
    };
  },
  components: {
    VueHtml2pdf,
  },
  created() {
    this.listar();
  },

  methods: {
    abrirNuevo() {
      this.verNuevo = 1;
      this.verDet = 0;
      this.correlativo = true;
      var today = new Date();
      this.fechaCreacion =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate() +
        " " +
        new Date().getHours() +
        ":" +
        new Date().getMinutes() +
        ":" +
        new Date().getSeconds();
    },
    cerrarNuevo() {
      this.verNuevo = 0;
      this.limpiar();
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.facturas = [];
      me.overlay = true;
      axios
        .get("api/FormFacturaSujetoExcluidos/Listar", configuracion)
        .then(function (response) {
          me.overlay = false;
          me.facturas = response.data;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    filtrarFacturas() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.facturas = [];
      me.overlay = true;
      axios
        .get(
          "api/FormFacturaSujetoExcluidos/Listar/" +
            me.fechaInicio +
            "/" +
            me.fechaFin,
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.facturas = response.data;
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    verDetalles(item) {
      this.idFactura = item.idSujetoExcluido;
      this.numFactura = item.numFactura;
      this.fechaCreacion = item.fechaCreacion;
      this.fecha = item.fecha;
      this.nombre = item.nombre;
      this.direccion = item.direccion;
      this.tel = item.tel;
      this.departamento = item.departamento;
      this.nitDui = item.nitDui;
      this.cadenaCantidad = item.cant;
      this.cadenaDescripcion = item.descripcion;
      this.cadenaPrecioUnitario = item.precioUnitario;
      this.cadenaTotalCompras = item.totalCompras;
      var list_cant = item.cant.split("~");
      var list_desc = item.descripcion.split("~");
      var list_pu = item.pUnitario.split("~");
      var list_tc = item.totalCompras.split("~");
      for (var i = 0; i < list_cant.length; i++) {
        var variableCant = "cant_" + (i + 1);
        var variableDesc = "descripcion_" + (i + 1);
        var variablePU = "precioUnitario_" + (i + 1);
        var variableTC = "totalCompras_" + (i + 1);
        this[variableCant] = list_cant[i];
        this[variableDesc] = list_desc[i];
        this[variablePU] = list_pu[i];
        this[variableTC] = list_tc[i];
      }
      this.sumas = item.sumas;
      this.impRenta = item.impRenta;
      this.subTotal = item.subTotal;
      this.montoDolares = item.total;
      this.verNuevo = 1;
      this.verDet = 1;
    },
    cadenaCant() {
      this.cadenaCantidad = "";
      if (document.getElementById("cant1").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad + document.getElementById("cant1").innerText;
      }
      if (document.getElementById("cant2").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant2").innerText;
      }
      if (document.getElementById("cant3").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant3").innerText;
      }
      if (document.getElementById("cant4").innerText) {
        this.cadenaCantidad =
          this.cadenaCantidad +
          "~" +
          document.getElementById("cant4").innerText;
      }
    },
    cadenaDesc() {
      this.cadenaDescripcion = "";
      if (document.getElementById("desc1").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion + document.getElementById("desc1").innerText;
      }
      if (document.getElementById("desc2").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc2").innerText;
      }
      if (document.getElementById("desc3").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc3").innerText;
      }
      if (document.getElementById("desc4").innerText != "") {
        this.cadenaDescripcion =
          this.cadenaDescripcion +
          "~" +
          document.getElementById("desc4").innerText;
      }
    },
    cadenaPU() {
      this.cadenaPrecioUnitario = "";
      if (document.getElementById("pu1").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario + document.getElementById("pu1").innerText;
      }
      if (document.getElementById("pu2").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu2").innerText;
      }
      if (document.getElementById("pu3").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu3").innerText;
      }
      if (document.getElementById("pu4").innerText != "") {
        this.cadenaPrecioUnitario =
          this.cadenaPrecioUnitario +
          "~" +
          document.getElementById("pu4").innerText;
      }
    },
    cadenaTC() {
      this.cadenaTotalCompras = "";
      if (document.getElementById("va1").innerText != "") {
        this.cadenaTotalCompras = document.getElementById("va1").innerText;
      }
      if (document.getElementById("va2").innerText != "") {
        this.cadenaTotalCompras =
          this.cadenaTotalCompras +
          "~" +
          document.getElementById("va2").innerText;
      }
      if (document.getElementById("va3").innerText != "") {
        this.cadenaTotalCompras =
          this.cadenaTotalCompras +
          "~" +
          document.getElementById("va3").innerText;
      }
      if (document.getElementById("va4").innerText != "") {
        this.cadenaTotalCompras =
          this.cadenaTotalCompras +
          "~" +
          document.getElementById("va4").innerText;
      }
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .post(
          "api/FormFacturaSujetoExcluidos/Crear",
          {
            numFactura: me.numFactura,
            fechaCreacion: me.fechaCreacion,
            fecha: me.fecha,
            nombre: me.nombre,
            direccion: me.direccion,
            nitDui: me.nitDui,            
            cant: me.cadenaCantidad,
            descripcion: me.cadenaDescripcion,
            tel: me.tel,
            pUnitario: me.cadenaPrecioUnitario,
            totalCompras: me.cadenaTotalCompras,
            sumas: me.sumas,
            impRenta: me.impRenta,
            subTotal: me.subTotal,
            total: me.montoDolares,
          },
          configuracion
        )
        .then(function (response) {
          me.overlay = false;
          me.limpiar();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    actualizar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      axios
        .put(
          "api/FormFacturaSujetoExcluidos/Actualizar",
          {
            idSujetoExcluido: me.idFactura,
            numFactura: me.numFactura,
            fechaCreacion: me.fechaCreacion,
            fecha: me.fecha,
            nombre: me.nombre,
            direccion: me.direccion,
            nitDui: me.nitDui,            
            cant: me.cadenaCantidad,
            descripcion: me.cadenaDescripcion,
            tel: me.tel,
            pUnitario: me.cadenaPrecioUnitario,
            totalCompras: me.cadenaTotalCompras,
            sumas: document.getElementById("sumas").innerText,
            impRenta: document.getElementById("impRenta").innerText,
            subTotal: document.getElementById("subTotal").innerText,
            total: me.montoDolares,
          },
          configuracion
        )
        .then(function () {
          me.overlay = false;
          me.limpiar();
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
          me.snackError = true;
          me.overlay = false;
        });
    },
    habilitarCuadricula() {
      if (this.banderaCuadricula) {
        $("td,th").css({
          border: "1px solid #000000",
          "text-align": "center",
          //"font-size": "12px",
        });
      } else {
        $("td,th").css({
          border: "1px solid #ffffff",
          "text-align": "center",
          //"font-size": "12px",
        });
      }
    },
    habilitarTitulos() {
      if (this.banderaTitulos) {
        this.correlativo = true;
        $(".textStyleTabla1").css({
          color: "#000000",
        });

        $(".textStyle").css({
          color: "#000000",
        });
      } else {
        this.correlativo = false;
        $(".textStyleTabla1").css({
          color: "#ffffff",
        });

        $(".textStyle").css({
          color: "#ffffff",
        });
      }
    },
    imprimir() {
      this.$refs.html2Pdf.generatePdf();
    },
    sumasTabla() {
      /////////////////////////////TOMA TODOS LOS DATOS DE LA COLUMNA Y HACE LOS CALCULOS
      this.sumas = 0;
      this.totalCompras_1 = "";
      if (
        document.getElementById("cant1").innerText != "" &&
        document.getElementById("pu1").innerText != ""
      ) {
        this.totalCompras_1 =
          parseFloat(document.getElementById("cant1").innerText) *
          parseFloat(document.getElementById("pu1").innerText);
      } else if (document.getElementById("va1").innerText != "") {
        this.totalCompras_1 = parseFloat(
          document.getElementById("va1").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.totalCompras_2 = "";
      if (
        document.getElementById("cant2").innerText != "" &&
        document.getElementById("pu2").innerText != ""
      ) {
        this.totalCompras_2 =
          parseFloat(document.getElementById("cant2").innerText) *
          parseFloat(document.getElementById("pu2").innerText);
      } else if (document.getElementById("va2").innerText != "") {
        this.totalCompras_2 = parseFloat(
          document.getElementById("va2").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.totalCompras_3 = "";
      if (
        document.getElementById("cant3").innerText != "" &&
        document.getElementById("pu3").innerText != ""
      ) {
        this.totalCompras_3 =
          parseFloat(document.getElementById("cant3").innerText) *
          parseFloat(document.getElementById("pu3").innerText);
      } else if (document.getElementById("va3").innerText != "") {
        this.totalCompras_3 = parseFloat(
          document.getElementById("va3").innerText
        );
      }
      //////////////////////////////////////////////////////////////////////////////////////////////
      this.totalCompras_4 = "";
      if (
        document.getElementById("cant4").innerText != "" &&
        document.getElementById("pu4").innerText != ""
      ) {
        this.totalCompras_4 =
          parseFloat(document.getElementById("cant4").innerText) *
          parseFloat(document.getElementById("pu4").innerText);
      } else if (document.getElementById("va4").innerText != "") {
        this.ventasAfectas_4 = parseFloat(
          document.getElementById("va4").innerText
        );
      }
      ///////////////////ESTOS IF SON PARA EVITAR PONER TODOS LOS CEROS Y SE PUEDAN HACER LOS CALCULOS
      if (this.totalCompras_1 != "") {
        this.sumas = this.sumas + parseFloat(this.totalCompras_1);
      }
      if (this.totalCompras_2 != "") {
        this.sumas = this.sumas + parseFloat(this.totalCompras_2);
      }
      if (this.totalCompras_3 != "") {
        this.sumas = this.sumas + parseFloat(this.totalCompras_3);
      }
      if (this.totalCompras_4 != "") {
        this.sumas = this.sumas + parseFloat(this.totalCompras_4);
      }
      this.sumas.toFixed(2);
      this.renta();
      this.cadenaTC();
    },
    renta() {
      this.impRenta = document.getElementById("impRenta").innerHTML;
      this.impRenta = (this.sumas * 0.1).toFixed(2);
      this.impRenta = parseFloat(this.impRenta);
      this.totaltabla();
    },
    totaltabla() {
      this.montoDolares = (
        parseFloat(this.sumas) - parseFloat(this.impRenta)
      ).toFixed(2);
    },
    limpiar() {
      this.verNuevo = 0;
      this.verDet = 0;
      this.idFactura = "";
      this.fechaCreacion = "";
      this.numFactura = "***";
      this.fecha = "Fecha";
      this.nombre = "***";
      this.direccion = "***";
      this.tel = "***";
      this.nitDui = "***";
      this.banderaCuadricula = true;
      this.banderaTitulos = true;
      this.cadenaCantidad = "";
      this.cant_1 = "";
      this.cant_2 = "";
      this.cant_3 = "";
      this.cant_4 = "";
      this.cadenaDescripcion = "";
      this.descripcion_1 = "";
      this.descripcion_2 = "";
      this.descripcion_3 = "";
      this.descripcion_4 = "";
      this.cadenaPrecioUnitario = "";
      this.precioUnitario_1 = "";
      this.precioUnitario_2 = "";
      this.precioUnitario_3 = "";
      this.precioUnitario_4 = "";
      this.cadenaTotalCompras = "";
      this.totalCompras_1 = "";
      this.totalCompras_2 = "";
      this.totalCompras_3 = "";
      this.totalCompras_4 = "";
      this.sumas = 0;
      this.impRenta = 0;
      this.subTotal = 0;
      this.montoDolares = 0;
      this.cantidadLetras = "";
    },
    /////////////////////////////////////////////////////////////////////////////////////////
    conversionNumero() {
      this.montoDolares = document.getElementById("total").innerHTML;
      var lettet = this.numeroALetras(this.montoDolares, {
        plural: "dólares estadounidenses",
        singular: "dólar estadounidense",
        centPlural: "centavos",
        centSingular: "centavo",
      });
      this.cantidadLetras = lettet;
    },
    Unidades(num) {
      switch (num) {
        case 1:
          return "UN";
        case 2:
          return "DOS";
        case 3:
          return "TRES";
        case 4:
          return "CUATRO";
        case 5:
          return "CINCO";
        case 6:
          return "SEIS";
        case 7:
          return "SIETE";
        case 8:
          return "OCHO";
        case 9:
          return "NUEVE";
      }

      return "";
    },
    Decenas(num) {
      let decena = Math.floor(num / 10);
      let unidad = num - decena * 10;

      switch (decena) {
        case 1:
          switch (unidad) {
            case 0:
              return "DIEZ";
            case 1:
              return "ONCE";
            case 2:
              return "DOCE";
            case 3:
              return "TRECE";
            case 4:
              return "CATORCE";
            case 5:
              return "QUINCE";
            default:
              return "DIECI" + this.Unidades(unidad);
          }
        case 2:
          switch (unidad) {
            case 0:
              return "VEINTE";
            default:
              return "VEINTI" + this.Unidades(unidad);
          }
        case 3:
          return this.DecenasY("TREINTA", unidad);
        case 4:
          return this.DecenasY("CUARENTA", unidad);
        case 5:
          return this.DecenasY("CINCUENTA", unidad);
        case 6:
          return this.DecenasY("SESENTA", unidad);
        case 7:
          return this.DecenasY("SETENTA", unidad);
        case 8:
          return this.DecenasY("OCHENTA", unidad);
        case 9:
          return this.DecenasY("NOVENTA", unidad);
        case 0:
          return this.Unidades(unidad);
      }
    },
    DecenasY(strSin, numUnidades) {
      if (numUnidades > 0) return strSin + " Y " + this.Unidades(numUnidades);

      return strSin;
    },
    Centenas(num) {
      let centenas = Math.floor(num / 100);
      let decenas = num - centenas * 100;

      switch (centenas) {
        case 1:
          if (decenas > 0) return "CIENTO " + this.Decenas(decenas);
          return "CIEN";
        case 2:
          return "DOSCIENTOS " + this.Decenas(decenas);
        case 3:
          return "TRESCIENTOS " + this.Decenas(decenas);
        case 4:
          return "CUATROCIENTOS " + this.Decenas(decenas);
        case 5:
          return "QUINIENTOS " + this.Decenas(decenas);
        case 6:
          return "SEISCIENTOS " + this.Decenas(decenas);
        case 7:
          return "SETECIENTOS " + this.Decenas(decenas);
        case 8:
          return "OCHOCIENTOS " + this.Decenas(decenas);
        case 9:
          return "NOVECIENTOS " + this.Decenas(decenas);
      }

      return this.Decenas(decenas);
    },
    Seccion(num, divisor, strSingular, strPlural) {
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let letras = "";

      if (cientos > 0)
        if (cientos > 1) letras = this.Centenas(cientos) + " " + strPlural;
        else letras = strSingular;

      if (resto > 0) letras += "";

      return letras;
    },
    Miles(num) {
      let divisor = 1000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMiles = this.Seccion(num, divisor, "UN MIL", "MIL");
      let strCentenas = this.Centenas(resto);

      if (strMiles == "") return strCentenas;

      return strMiles + " " + strCentenas;
    },
    millon(num, singular) {
      var letraMillon = "";
      if (singular == true) letraMillon = "UN MILLON";
      else letraMillon = "MILLONES";
      if (num % 1000000 == 0) letraMillon = letraMillon + " DE";
      return letraMillon;
    },
    millones(num) {
      let divisor = 1000000;
      let cientos = Math.floor(num / divisor);
      let resto = num - cientos * divisor;

      let strMillones = this.Seccion(
        num,
        divisor,
        this.millon(num, true),
        this.millon(num, false)
      );
      let strMiles = this.Miles(resto);

      if (strMillones == "") return strMiles;

      return strMillones + " " + strMiles;
    },
    numeroALetras(num, currency) {
      let me = this;
      currency = currency || {};
      let data = {
        numero: num,
        enteros: Math.floor(num),
        centavos: Math.round(num * 100) - Math.floor(num) * 100,
        letrasCentavos: "",
        letrasMonedaPlural: currency.plural || "PESOS CHILENOS", //'PESOS', 'Dólares', 'Bolívares', 'etcs'
        letrasMonedaSingular: currency.singular || "PESO CHILENO", //'PESO', 'Dólar', 'Bolivar', 'etc'
        letrasMonedaCentavoPlural:
          currency.centPlural || "CHIQUI PESOS CHILENOS",
        letrasMonedaCentavoSingular:
          currency.centSingular || "CHIQUI PESO CHILENO",
      };

      if (data.centavos > 0) {
        data.letrasCentavos =
          "CON " +
          (function () {
            if (data.centavos == 1)
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoSingular
              );
            else
              return (
                me.millones(data.centavos) +
                " " +
                data.letrasMonedaCentavoPlural
              );
          })();
      }

      if (data.enteros == 0)
        return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
      if (data.enteros == 1)
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaSingular +
          " " +
          data.letrasCentavos
        );
      else
        return (
          me.millones(data.enteros) +
          " " +
          data.letrasMonedaPlural +
          " " +
          data.letrasCentavos
        );
    },
    generarObjetoExcel() {
      let me = this;
      me.exportData = [];

      for (var i = 0; i < me.facturas.length; i++) {
        me.exportData.push({
          "Numero factura": me.facturas[i].numFactura,
          "Fecha creacion": me.formatoFecha(me.facturas[i].fechaCreacion),
          Fecha: me.facturas[i].fecha,
          Nombre: me.facturas[i].nombre,
          Direccion: me.facturas[i].direccion,
          Telefono: me.facturas[i].tel,
          "NIT o DUI": me.facturas[i].nitDui,
          Sumas: me.facturas[i].sumas,
          "Impuesto sobre la renta": me.facturas[i].impRenta,
          "Sub-Total": me.facturas[i].subTotal,
          Total: me.facturas[i].total,
        });
      }
      me.generarExcel();
    },
    generarExcel() {
      let me = this;
      let data = XLSX.utils.json_to_sheet(me.exportData);
      const workbook = XLSX.utils.book_new();
      const filename = "Sujeto excluido";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
      me.limpiar();
    },
    formatoFecha(fecha){
      return moment(fecha).format("DD/MM/YYYY");
    }
  },
};
</script>

<style scoped>
.some-style >>> .v-input__slot::before {
  border-style: none !important;
}
.some-style {
  margin-left: 5px;
}
.textStyle {
  padding-left: 25px;
  padding-bottom: 0px;
  font-weight: bold;
  color: rgb(0, 0, 0);
}
.textStyleTabla1 {
  padding-right: 4px;
  color: rgb(0, 0, 0);
}
.paddingText {
  padding-left: 0px;
  padding-right: 0px;
}
table {
  width: 100%;
  table-layout: fixed;
}
td,
th {
  border: 1px solid #000000;
  text-align: center;
  font-size: 12px;
}
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
.styleText {
  font-family: "Open Sans", sans-serif;
  font-size: 15px;
  font-weight: bold;
}
</style>
